// GW 監査ラン履歴 API クライアント。GET /gw/audit/runs(一覧) / /gw/audit/runs/{id}(詳細)。
// ApiClient に認証・エラー正規化を委譲。backend GwRunSummary/GwRunRecord に対応する DTO。
// SF history-api.ts のミラー（orgId を domain に置換・/gw）。
import type { ApiClient } from "../api/client";

export interface HistoryApiDeps {
  readonly apiClient: ApiClient;
}

export interface RunCountsDto {
  readonly critical: number;
  readonly high: number;
  readonly medium: number;
  readonly low: number;
}

export interface RunSummaryDto {
  readonly runId: string;
  readonly runAt: string;
  readonly healthCheckScore: number;
  readonly counts: RunCountsDto;
  readonly domain: string;
  readonly trigger: string;
  readonly actorSub: string;
}

export interface RunDetailDto extends RunSummaryDto {
  readonly findings: { readonly checkId: string; readonly status: string; readonly affectedCount: number; readonly affectedResources: string[] }[];
  readonly coverage: { readonly evaluated: string[]; readonly notEvaluated: string[] };
}

// GET /gw/audit/runs → RunSummaryDto[]（新しい順は backend が保証）
export async function listRuns(deps: HistoryApiDeps): Promise<RunSummaryDto[]> {
  return deps.apiClient.get<RunSummaryDto[]>("/gw/audit/runs");
}

// GET /gw/audit/runs/{runId} → RunDetailDto（findings 込み）
export async function getRun(deps: HistoryApiDeps, runId: string): Promise<RunDetailDto> {
  return deps.apiClient.get<RunDetailDto>(`/gw/audit/runs/${encodeURIComponent(runId)}`);
}
